(function(){
  var form=document.getElementById('bp-quiz-form');
  if(!form)return;
  var cards=Array.prototype.slice.call(document.querySelectorAll('#bp-quiz-results .bp-quiz-card'));
  var status=document.getElementById('bp-quiz-status');
  var browse=document.getElementById('bp-quiz-browse');
  var personInput=document.getElementById('bp-quiz-person');
  var typeInput=document.getElementById('bp-quiz-type');
  var budgetInput=document.getElementById('bp-quiz-budget');
  var destinations={grandpa:['/collections/gifts-for-grandpa','Explore all gifts for Grandpa'],dad:['/collections/gifts-for-dad','Explore all gifts for Dad'],mom:['/collections/gifts-for-mom','Explore all gifts for Mom'],uncle:['/collections/gifts-for-uncle','Explore all gifts for an uncle'],dog:['/collections/t-shirts','Explore more T-shirts'],vet:['/collections/gifts-by-occupation-and-profession','Explore gifts by profession'],any:['/collections/family-friends','Explore all family & friend gifts']};
  function setBrowse(person){
    var destination=destinations[person]||destinations.any;
    browse.href=destination[0];
    browse.textContent=destination[1]+' ↗';
  }
  function startingPicks(){
    cards.forEach(function(card,i){card.hidden=i>2});
    status.textContent='A few starting points from the shop.';
    setBrowse('any');
  }
  function showMatches(focusStatus){
    var person=personInput.value,type=typeInput.value,budget=budgetInput.value;
    var matches=cards.filter(function(card){
      return(person==='any'||card.dataset.person===person)&&(type==='any'||card.dataset.format===type)&&(budget==='any'||Number(card.dataset.price)<Number(budget));
    });
    cards.forEach(function(card){card.hidden=matches.indexOf(card)<0});
    status.textContent=matches.length?matches.length+' '+(matches.length===1?'gift matches':'gifts match')+' your choices. Choose a favorite to see its options.':'No exact match in these featured picks. Try another format or budget, or explore the collection below.';
    setBrowse(person);
    if(focusStatus)status.focus();
  }
  startingPicks();
  form.addEventListener('submit',function(event){event.preventDefault();showMatches(true)});
  form.addEventListener('change',function(){showMatches(false)});
  document.getElementById('bp-quiz-reset').addEventListener('click',function(){form.reset();startingPicks();personInput.focus()});
})();